import React, { useState, useEffect } from "react"
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from "@date-io/date-fns";
import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import { DatePicker } from '@material-ui/pickers';
import Format from "date-fns/format";
import axios from 'axios';
import { ReportingService } from "../../../utils/web_config_2";
import { useAuthUser } from "../../../hooks/useUserToken";
import { LoadingScreen } from "../atoms/loading-card";
import { it } from "date-fns/locale";

function StepOneTable({
	loading = false,
	filter_for_level2,
	startDate,
	endDate,
	data,
}) {

	if (loading) return <LoadingScreen />;


	return (
		<Card>
			<MUIDataTable
				title={
					<div>
						From {startDate.value} to {endDate.value}
					</div>
				}
				data={data}
				columns={[
					{
						name: 'Trips',
					},
					{
						name: 'Route',
						options: {
							customBodyRender: (value, tableMeta, updateValue) => (
								<Link
									onClick={() => {
										var currency = tableMeta.rowData[5];
										filter_for_level2(value,currency);
									}}
								>
									{value}
								</Link>
							),
						},
					},
					'Actual Revenue',
					'Expected Revenue',
					'Performance Rate',
					'Currency'
				]}
				options={{
					filterType: 'checkbox',
				}}
			/>
		</Card>
	);
}

function StepTwoTable({
	loading = false,
	goBack,
	route,
	startDate,
	endDate,
	setStep,
	setSelectedRoute,
	data,
}) {
	if (loading) return <LoadingScreen />;

	return (
		<>
			<Button color='primary' onClick={goBack}>
				Go Back.
			</Button>
			<Card>
				<MUIDataTable
					title={
						<div>
							Route: {route} From: {startDate.value} to {endDate.value}
						</div>
					}
					data={data}
					columns={[
						'Date',
						'Time',
						'Driver name',
						'Plate Number',
						'Vehicle Capacity',
						'Allowed seats',
						'Total Sold seats',
						'Total Sales',
						'Luggages',
						'Luggage Sales',
						'Currency'
					]}
					options={{
						filterType: 'checkbox',
					}}
				/>
			</Card>
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up("sm")]: {
			marginLeft: 250,
		},
	},
}));

export default function RoutePerformanceReport(){
	const [isLoading, setIsLoading] = useState(false);

  const [showFilterDialog, setShowFilterDialog] = useState(false)
  const [reportLoad, setReportLoad] = useState(false)
	const [authUser, setAuthUser] = useState()
	const [data, setData] = useState([])
	const [data2, setData2] = useState([])
	const [selectedRoute, setSelectedRoute] = useState("")
	const [step, setStep] = useState(1)

  const [startDate, setStartDate] = useState({
		value: Format(new Date(), ["yyyy-MM-dd"]),
		error: "",
	});
  const [endDate, setEndDate] = useState({
		value: Format(new Date(), ["yyyy-MM-dd"]),
		error: "",
	});

  const styles = useStyles();

	const withStep = (out1, out2) => {
		if(step === 1) return out1
		else return out2
	};


	const { token, organization } = useAuthUser();

  async function filter_report(){
		setIsLoading(true)
		console.log("Route performance is triggered ....")
		setReportLoad(true)

		try {

			let req = {
				start_date: startDate.value,
				end_date: endDate.value,
				organization_id: organization.organization_id,
			};

			axios.defaults.baseURL = new ReportingService().BASE_URL;
			const reportInstance = axios.create(
				new ReportingService().setHeaders(token)
			);

			let {
				data: { data },
			} = await reportInstance.post("/api/v1/performance/for-routes",
				req
			);
			
			let formattedRows = [];
			for(let item of data){
				formattedRows.push([
					item.trips,
					item.route,
					item.actual_revenue,
					item.expected_revenue,
					item.performance_rate.toFixed(2),
					item.currency
				])
			}

			setData(formattedRows)

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			setData([])
		}

		setShowFilterDialog(false)
		setReportLoad(false)
  }

  useEffect(() => {
		let op = localStorage.getItem("nx_op")
		if(!op) return;

		filter_report()

		setAuthUser(JSON.parse(op))
  }, [])

	async function filter_for_level2(value, currency){
		setIsLoading(true)
		setStep(2)
		setSelectedRoute(value)

		let {
			organization: { organization_id },
			token,
		} = authUser;

		let req = {
			start_date: startDate.value,
			end_date: endDate.value,
			organization_id,
		};

		axios.defaults.baseURL = new ReportingService().BASE_URL;
		const reportInstance = axios.create(
			new ReportingService().setHeaders(token)
		);

		let {
			data: { data },
		} = await reportInstance.post("/api/v1/performance/for-routes/" +
				value,
			req
		);
		

		let formattedRows = []

		data = data.filter((item) => item.currency === currency)

		console.log(data)

		for(let item of data) {
			formattedRows.push([
				item.date,
				item.time,
				item.driver_name,
				item.plate_number,
				item.vehicle_capacity,
				item.allowed_seats,
				item.total_sold_seats,
				item.total_sales,
				item.luggage,
				item.luggage_sales,
				item.currency
			]);
		}

		setData2(formattedRows);
		setIsLoading(false)
	}

  return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div>
				<div className={styles.root}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						paddingBottom={'40px'}
					>
						<Typography variant='h5' color='default'>
							<b>
								Route Performance Report{' '}
								{withStep('', 'Level Two => [' + selectedRoute + ']')}
							</b>
						</Typography>

						<Button
							onClick={() => setShowFilterDialog(true)}
							color='primary'
							variant='contained'
						>
							Filter
						</Button>
					</Box>

					{withStep(
						<StepOneTable
							startDate={startDate}
							endDate={endDate}
							setStep={setStep}
							setSelectedRoute={setSelectedRoute}
							filter_for_level2={filter_for_level2}
							data={data}
							loading={isLoading}
						/>,
						<StepTwoTable
							route={selectedRoute}
							startDate={startDate}
							endDate={endDate}
							goBack={() => {
								setStep(1);
							}}
							data={data2}
							loading={isLoading}
						/>
					)}
				</div>

				<Dialog
					maxWidth='sm'
					fullWidth
					open={showFilterDialog}
					onClose={() => {
						setShowFilterDialog(false);
					}}
					aria-labelledby='filter'
					aria-describedby='filter'
				>
					<DialogTitle id='filter'>{'Filter'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='Start date'
										value={startDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											console.log('choosen1: ', Format(v, ['yyyy-MM-dd']));

											setStartDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='End date'
										value={endDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											console.log('choosen2: ', v);
											setEndDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={() => {
								setShowFilterDialog(false);
							}}
							color='secondary'
						>
							<Typography>Close</Typography>
						</Button>

						<Button
							onClick={() => {
								filter_report();
							}}
							color='primary'
							variant='contained'
						>
							{reportLoad ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								<Typography>View</Typography>
							)}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</MuiPickersUtilsProvider>
	);
}